/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_TitleInputs */

const en_gc_resources_guide_formulas_title = /** @type {(inputs: Gc_Resources_Guide_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make SUM and IF work for you.`)
};

const zh_gc_resources_guide_formulas_title = /** @type {(inputs: Gc_Resources_Guide_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用好 SUM 与 IF。`)
};

/**
* | output |
* | --- |
* | "Make SUM and IF work for you." |
*
* @param {Gc_Resources_Guide_Formulas_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_title = /** @type {((inputs?: Gc_Resources_Guide_Formulas_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_title(inputs)
	return zh_gc_resources_guide_formulas_title(inputs)
});
export { gc_resources_guide_formulas_title as "gc.resources.guide.formulas.title" }